export default {"src":"/_next/static/media/redact-not-found.dc0620a1.svg","height":598,"width":752,"blurWidth":0,"blurHeight":0};